import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

// Get seller contacts
export const get_seller_contacts = createAsyncThunk(
  'contact/get_seller_contacts',
  async ({ sellerId, pageNo, status, searchValue, parPage }, { rejectWithValue, fulfillWithValue }) => {
    try {
      let url = `/seller/contacts/${sellerId}?page=${pageNo}&parPage=${parPage}`;
      
      if (status && status !== 'all') {
        url += `&status=${status}`;
      }
      
      if (searchValue) {
        url += `&searchValue=${searchValue}`;
      }
      
      const { data } = await api.get(url, { withCredentials: true });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Update contact status
export const update_contact_status = createAsyncThunk(
  'contact/update_contact_status',
  async ({ contactId, status, sellerId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put(`/seller/contact/${contactId}/status`, { status }, { withCredentials: true });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const contactReducer = createSlice({
  name: 'contact',
  initialState: {
    contacts: [],
    totalContacts: 0,
    currentPage: 1,
    totalPages: 1,
    loading: false,
    successMessage: '',
    errorMessage: ''
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    }
  },
  extraReducers: (builder) => {
    builder
      // Get seller contacts
      .addCase(get_seller_contacts.pending, (state) => {
        state.loading = true;
      })
      .addCase(get_seller_contacts.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.contacts = payload.contacts;
        state.totalContacts = payload.totalContacts;
        state.currentPage = payload.currentPage || 1;
        state.totalPages = payload.totalPages || 1;
      })
      .addCase(get_seller_contacts.rejected, (state, { payload }) => {
        state.loading = false;
        state.errorMessage = payload?.message || 'Failed to fetch contacts';
      })
      
      // Update contact status
      .addCase(update_contact_status.pending, (state) => {
        state.loading = true;
      })
      .addCase(update_contact_status.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.successMessage = payload.message;
        // Update the contact in the list
        const contactIndex = state.contacts.findIndex(contact => contact._id === payload.contact._id);
        if (contactIndex !== -1) {
          state.contacts[contactIndex] = payload.contact;
        }
      })
      .addCase(update_contact_status.rejected, (state, { payload }) => {
        state.loading = false;
        state.errorMessage = payload?.message || 'Failed to update contact status';
      });
  }
});

export const { messageClear } = contactReducer.actions;
export default contactReducer.reducer; 